<template>
  <div>

    <div>
      <div class="vuse-content-wrapper mt-4">
        <v-row >
          <v-col cols="12" md="2" class="mt-0">
            <h2 class="ml-3 float-left">
              <span>
                <v-tooltip top>
                  <template v-slot:activator="{ on }">     
                    <v-btn icon color="primary" v-on="on" @click="xmlReport">
                      <ExcelIcon />
                    </v-btn>
                  </template>
                  <span>Download Table as CSV</span>
                </v-tooltip>
              </span>
              <span>
                <v-tooltip top>
                  <template v-slot:activator="{ on }">     
                    <v-btn icon color="primary" v-on="on" @click="loadData">
                      <v-icon>sync</v-icon>
                    </v-btn>
                  </template>
                  <span>Refresh</span>
                </v-tooltip>
              </span>
             {{$t(page+'.Payments')}}
            </h2>
          </v-col>
          <v-spacer />
          <v-col class="text-right" cols="12" md="2">
            <v-btn color="black" class="mr-3" dark @click.stop="timeframe_dialog = true" v-if="timeframe">
              <v-icon left dark>
                mdi-calendar
              </v-icon>
              {{formattedTimeframe}}
            </v-btn>
          </v-col> 
        </v-row>
        <!--<v-row v-if="!orders">
          <no-data />  
        </v-row>-->

        <v-row class="mt-0">
          <v-col cols="12" class="mt-2">
            <v-card class="neu-glow pb-4">
              <v-card-title>
                <v-col cols=12 sm="6" lg="6" >
                  <v-btn-toggle v-model="selectedTable">
                    <v-btn small color="info" v-for="table in tables" :key="table">
                      <v-icon left>fas fa-eye</v-icon>{{table}}
                    </v-btn>
                  </v-btn-toggle>
                </v-col>
                <v-spacer></v-spacer>
                <v-text-field
                    v-model="search"
                    append-icon="search"
                    label="Search"
                    single-line
                    hide-details
                    style="max-width:250px"
                ></v-text-field>
              </v-card-title>
              <v-data-table
                  item-key="en"
                  dense
                  v-model="selectedSentence"
                  fixed-header="true"
                  :headers="i18_headers"
                  :items="sentences==null?[]:sentences"
                  :items-per-page="Math.floor((wIH - 362-59)/39.53)"
                  :height="wIH - 362"
                  :search="search"
                  multi-sort
                  class="elevation-1 mx-4"
                  :loading="loading" 
                  :loading-text="$t(page+'.Loading... Please wait')"
                  :no-data-text="$t(page+'.Please select a Status')"
                  :no-results-text="$t(page+'.No Record matching search parameters')"
                >

              </v-data-table>
            </v-card>
          </v-col>
        </v-row>        
      </div>
    </div>
  </div>
</template>
<style>
  .bordered::before{
    border-color:transparent;
    border: 6px solid green!important;
  }
  .bottomborder::before{
    border-color:transparent;
    border-bottom: 8px solid blue!important;
  }
  .wrapped{
    height:60px!important;
    border-style:none!important;
  }
  .v-btn:before{
    background-color: inherit!important;
  }
  .v-btn--active:before{
    opacity:1!important;
  }
  .v-btn__content{
    display:block!important;
    }
  .v-btn-vertical{
    flex-direction: column!important;
  }
</style>
<script>
import { mapGetters } from "vuex";
import NoData from "@/components/NoData";
import ExcelIcon from "@/components/Excel";
import SkeletonRevenue from "@/components/SkeletonRevenue";
import { availableCountries  } from "@/config/countries";
import DoughnutChart from "@/components/ChartJS/DoughnutChart";

import _ from 'lodash'
export default {
  components: { NoData, SkeletonRevenue, ExcelIcon, availableCountries,DoughnutChart},
  computed : {
    ...mapGetters(["user","settings","orders","shippingServices","shipping_departures","active_status","active_carriers","carriers","status","shipping_options","departures","formattedTimeframe"]),
    active_carrier_value: function () {
      console.log(this.active_carriers);
    },
    i18_headers: function()
    {
      let H= this.headers
      H.map(h => 
      {
        h.text=this.$t(this.page+'.'+h.text);    
      });
      return H;
    },
  },    
  data() {
    return {
      namespace: "Reports",
      page: "BossTickets",
      tables:['Users','SideBar','Settings','Pricelists','Payments','Orders','Menu','Invoices','FixAddresses'],
      sentences: null,
      payload:{},
      loading: true,
      search: '',
      errorid: null,
      wIH:window.innerHeight,
      headers: [
          //{ text: '#', align: 'start', value: 'index', class : 'text-subtitle-1 font-weight-black primary--text py-4'},
          { text: 'Key', value: 'en',align: 'start', class : 'text-subtitle-1 font-weight-black primary--text py-4'},
          { text: 'English', value: 'en',align: 'start', class : 'text-subtitle-1 font-weight-black primary--text py-4'},
          { text: 'Italiano', value: 'it',align: 'start', class : 'text-subtitle-1 font-weight-black primary--text py-4'},
          { text: 'Chinese', value: 'zh',align: 'start', class : 'text-subtitle-1 font-weight-black primary--text py-4'}
      ],
    };
  },
  created(){
    this.loadData('Users')
  },
  methods:
  {
    rowClass:function(item){
      //return item.CODPaidDate!=''?'success':'';
      var clas=item.hasOwnProperty('paidOn')?'success':(item.overdue==1?'warning':'')
      return clas;
      //return item.hasOwnProperty('CODPaidDate')?'success':'';
    },
    refreshData(){
     let status=this.status[this.activeStatus].filter
     console.log(550,status,this.activeStatus,this.status);
      this.loadData(status);
    },
    async xmlReport(){
      let payload={"timeframe":this.timeframe.toString(),"sellers":this.activeeBayAccounts.toString()};
      window.location.href='/ajax/reports/revenue_xls.php?json='+encodeURIComponent(JSON.stringify(payload));
    },
    async loadData(table='Users'){
      this.loading=true;
      try{
          const payload={"action":"localize","table":table}
          const res = await this.$http.post('/boss/localize.php', payload );
          console.log(506,res)          
          switch (res.data.errorid)
          {
            case '0':
              sessionStorage.setItem('jwt', res.data.jwt);
              
              let p=res.data.payload;
              //this.$store.dispatch("setOrders", p.orders);
              this.totalAmount=p.orders[0].totalAmount;
              this.sentences=p;
              //this.departures=p.departures;
              console.log(346,res.data.payload,this.sentences)
              //this.availableShippingServices=this.shipping_options;
              //this.loading= false;
            break;

            case '0001':

            break;

            case '0006':
              this.$router.push('/auth/login').catch(() => {});
            break;
          }
          this.loading=false;

      } catch(e)
      {
          this.loading= false;
          //console.log(res.data);
      }
      this.loading= false;
    }
  },
};
</script>
<!--<style scoped>
.theme--light.v-messages{
  display:none;
}
</style>-->